export const DEFAULT_COUNTRY = 'US';

const LANGUAGE_ENGLISH = 'en';

export const LANGUAGES = {
    en: {
        id: LANGUAGE_ENGLISH,
        locale: 'en_GB',
        title: 'language.en',
    },
};
export const DEFAULT_LANGUAGE = LANGUAGE_ENGLISH;

export const FILES_CONFIG = {
    default: {
        accept: '*',
        fileTypes: '*.*',
        size: {
            height: 100,
            width: 100,
        },
    },
    profileImage: {
        accept: [
            'image/png',
            'image/jpg',
            'image/jpeg',
        ],
        fileTypes: '.jpg, .jpeg, .png',
        size: {
            height: 500,
            width: 500,
        },
    },
};

export const MAX_FILE_SIZE = 10485760;

export const TEXT_EDITOR_CONFIG = {
    block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5',
    menubar: false,
    plugins: [
        'advlist lists link charmap paste charmap emoticons',
    ],
    toolbar: [
        'undo redo | cut copy paste pastetext | formatselect',
        'bold italic underline strikethrough superscript subscript | forecolor backcolor | charmap emoticons',
        'alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | removeformat selectall',
    ],
};
